import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {queryAll} from 'lit-element';
import {i18nMixin} from '@aofl/i18n-mixin';
import {recommendedActivityType, sdoNs, supportedLocalesMap} from '@modules/constants-enumerate';
import translations from '@modules/i18n';
import {storeInstance} from '@aofl/store/dist/legacy';
import {ApiService} from '@modules/api-service';

/**
 * @summary AcademyRecommendedActivity
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('academy-recommended-activity')
class AcademyRecommendedActivity extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of AcademyRecommendedActivity.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  @property({type: Array})
  activities = []

  @property({type: String})
  ['default-type'] = recommendedActivityType.GROUP;

  @property({type: Object, attribute: false})
  activeRecommendedActivity = {};

  @property({type: Object})
  collapseOpen = {
    english_language_supports: false,
    social_emotional_supports: false,
    success_strategies: false,
    english_learner_supports: false,
  };

  @property({type: String})
  skillName = '';

  @property({type: Object})
  recommendedActivityTypes = {
    [recommendedActivityType.GROUP]: false,
    [recommendedActivityType.ONE_ON_ONE]: false
  }

  @queryAll('.content img')
  elsSesImgs = [];

  @property({type: Object})
  showPdfButton = {};

  @property({type: Boolean})
  ['for-student-view'] = false;

  @property({type: Boolean})
  forGroupSupport = false;

  connectedCallback() {
    super.connectedCallback();
    const activityIds = [];
    this.activities?.map((activity) => {
      activityIds.push(activity.id);
      this.recommendedActivityTypes[activity.type] = true;
      if (this['default-type'] && this['default-type'] === activity.type) {
        this.activeRecommendedActivity = activity;
      }
    });
    if (Object.keys(this.activeRecommendedActivity || {}).length === 0) {
      this.activeRecommendedActivity = this.activities[0] || {};
    }
    ApiService.recommendedActivityIsDownloadable(activityIds)
      .then((response) => {
        response.statuses.map((status) => {
          this.showPdfButton = {
            ...this.showPdfButton,
            [status.id]: (selectedLanguage === supportedLocalesMap.en && !this.forGroupSupport && status.is_downloadable)
          };
        });
      });
    const state = storeInstance.getState();
    const selectedLanguage = state[sdoNs.LOCALE_DD].selected.code;
  }

  updated(changedProperties) {
    if (changedProperties.has('activeRecommendedActivity')) {
      this.elsSesImgs?.forEach((img) => {
        img.addEventListener('click', () => {
          this.collapseOpen = {
            english_language_supports: true,
            social_emotional_supports: true
          };
        });
      });
    }
  }

  changeAudience(e) {
    const type = e.composedPath()[0].value;
    this.activities?.map((activity) => {
      if (type === activity.type) {
        this.activeRecommendedActivity = activity;
      }
    });
  }

  toggleCollapse(field) {
    this.collapseOpen = {
      ...this.collapseOpen,
      [field]: !this.collapseOpen[field]
    };
  }

  /**
   * @readonly
   */
  static is = 'academy-recommended-activity';

  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default AcademyRecommendedActivity;
